import type { HomepageLayoutContent } from '../components/sections/sectionRegistry';
import { createPageLayout, listPageLayoutsForAdmin } from './pageLayoutsDraft';

export const EVENTS_PAGE_KEY = 'events';
export const EVENTS_PAGE_TITLE = 'Events';

export const DEFAULT_EVENTS_LAYOUT_CONTENT: HomepageLayoutContent = {
  version: 1,
  flows: [],
  flowState: {},
  sections: [
    {
      type: 'events',
      settings: {
        paddingTop: 'lg',
        paddingBottom: 'xl',
        maxWidth: 'full',
        background: 'default',
        events: {
          heading: 'Events & Dates',
          description: 'Join us at upcoming events and stay informed about important dates.',
          upcomingTitle: 'Upcoming Events',
          pastTitle: 'Recent Past Events',
          emptyTitle: 'No upcoming events at the moment.',
          emptyDescription: 'Check back soon for new announcements.',
          showHomeLink: true,
          homeLinkLabel: 'Back to Home',
          showPastEvents: true,
          pastMonths: 3,
          pastLimit: 6,
        },
      },
    },
  ],
};

let ensureEventsPagePromise: Promise<void> | null = null;

export async function ensureEventsPageLayout() {
  if (ensureEventsPagePromise) return ensureEventsPagePromise;

  ensureEventsPagePromise = (async () => {
    const pagesRes = await listPageLayoutsForAdmin();
    if (pagesRes.error) throw pagesRes.error;

    const exists = (pagesRes.data ?? []).some((row) => row.page_key === EVENTS_PAGE_KEY);
    if (exists) return;

    const { error } = await createPageLayout({
      pageKey: EVENTS_PAGE_KEY,
      title: EVENTS_PAGE_TITLE,
      draftContent: DEFAULT_EVENTS_LAYOUT_CONTENT,
      publishedContent: DEFAULT_EVENTS_LAYOUT_CONTENT,
    });

    if (error) {
      const message = String((error as any)?.message ?? '').toLowerCase();
      if (!message.includes('already exists') && !message.includes('duplicate')) {
        throw error;
      }
    }
  })();

  try {
    await ensureEventsPagePromise;
  } finally {
    ensureEventsPagePromise = null;
  }
}
